<template>
    <kt-row style="margin-bottom: 50px">
        <div v-for="(account,index) in application.bank_accounts" v-bind:key="index" class="col-12">
            <hr v-if="index != 0" :id="'account_hr_tag'+index">
            <kt-row>
                <kt-col xs="6" sm="5" md="4" lg="3">
                    <p style="font-size: medium;display: inline-block">
                        {{ $t('application.account_detail') }}{{ ' ' }}{{ $i18n.t('ordinal_numbers.' + [index + 1]) }}
                    </p>
                </kt-col>
                <kt-col xs="1" sm="2" md="4" lg="6">
                </kt-col>
                <kt-col xs="5" sm="5" md="4" lg="3">
                    <kt-form-group>
                        <a @click="deleteBankAccount(index)"
                           :id="'delete_bank_account_btn'+index"
                           class="w-100 h-100 p-2 pt-3 btn-sm btn btn-label-danger btn-bold float-right">
                            <i class="la la-trash-o"></i>
                            {{ $t('btn.delete') }}
                        </a>
                    </kt-form-group>

                </kt-col>
            </kt-row>

            <kt-row style="margin-top: 20px">
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="first_name">
                            {{ $t("label.first_name") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="rtl"
                            disabled
                            :name="'accounts.'+index +'.first_name'"
                            :id="'account_first_name'+index"
                            v-model="account.first_name"
                        ></kt-form-control>
                        <p :id="'first_name_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="last_name">
                            {{ $t("label.last_name") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="rtl"
                            disabled
                            :name="'accounts.'+index +'.last_name'"
                            :id="'account_last_name'+index"
                            v-model="account.last_name"
                        ></kt-form-control>
                        <p :id="'last_name_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="account_bank_id">
                            {{ $t("label.bank_name") }}
                        </kt-form-label>
                        <kt-form-select
                            size="3"
                            disabled
                            class="form-control"
                            :name="'accounts.'+index +'.bank_id'"
                            :id="'account_bank_id'+index"
                            v-model="account.bank_id"
                        >
                            <option
                                v-bind:key="bank_id"
                                v-for="(bank_id, index) in banks"
                                v-bind:value="bank_id"
                            >
                                {{ $t("wallets.bank." + index) }}
                            </option>
                        </kt-form-select>
                        <p :id="'account_bank_id_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="account_account_number">
                            {{ $t("label.account_number") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            disabled
                            :name="'accounts.'+index +'.account_number'"
                            :id="'account_account_number'+index"
                            v-model="account.account_number"
                        ></kt-form-control>
                        <p :id="'account_account_number_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="account_iban">
                            {{ $t("label.iban") }}
                        </kt-form-label>
                        <kt-form-control
                            style="direction: ltr"
                            disabled
                            class="form-control sheba"
                            :name="'accounts.'+index +'.iban'"
                            :id="'account_iban'+index"
                            v-model="account.iban"
                        ></kt-form-control>
                        <p :id="'account_iban_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                    <kt-form-group>
                        <kt-form-label for="account_shahab_code">
                            {{ $t("open_banking.shahab_code") }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            disabled
                            :name="'accounts.'+index +'.shahab_code'"
                            :id="'account_shahab_code'+index"
                            v-model="account.shahab_code"
                        ></kt-form-control>
                        <p :id="'shahab_code_error'+index"
                           style="font-size: x-small;color: #fd397a;margin-top: 5px"></p>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6" md="6" lg="6">
                        <div class="text-black" :class="getBankAccountStatusClass(account.status)"> {{ $t('label.status') }} : {{bankAccessTokenStatusStr.get(account.status)}}</div>
                </kt-col>
            </kt-row>
        </div>
        <div class="col-12">
            <kt-col xs="7" sm="5" md="4" lg="3" style="position: absolute;left:0;top: 20px">
                <div
                    type="button"
                    data-toggle="modal"
                    data-target="#add-bank-acoount-modal"
                    id="add_bank_account_btn"
                    class="kt-nav__link m-2 btn btn-outline-primary float-right"
                >
                    + {{ $t('application.add_new_account') }}
                </div>

            </kt-col>
        </div>
        <hr>

        <!--        Modal-->
        <div id="add-bank-acoount-modal" class="modal fade" role="dialog">
            <div class="modal-dialog" style="max-width: 700px">
                <!-- Modal content-->
                <div class="modal-content" id="bank-accounts-access-modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            {{ $t('application.add_new_account') }}
                        </h4>
                        <button type="button" id="close_modal" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="add_new_bank_account_form">
                            <kt-row style="margin-top: 20px">
                                <kt-col xs="12" sm="6" md="6" lg="6">
                                    <kt-form-group>
                                        <kt-form-label for="new_account_first_name">
                                            {{ $t("label.first_name") }}
                                        </kt-form-label>
                                        <kt-form-control
                                            dir="rtl"
                                            name="new_account_first_name"
                                            id="new_account_first_name"
                                            v-model="new_account.first_name"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6" lg="6">
                                    <kt-form-group>
                                        <kt-form-label for="new_account_last_name">
                                            {{ $t("label.last_name") }}
                                        </kt-form-label>
                                        <kt-form-control
                                            dir="rtl"
                                            name="new_account_last_name"
                                            id="new_account_last_name"
                                            v-model="new_account.last_name"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6" lg="6">
                                    <kt-form-group>
                                        <kt-form-label for="account_bank_id">
                                            {{ $t("label.bank_name") }}
                                        </kt-form-label>
                                        <kt-form-select
                                            size="3"
                                            class="form-control"
                                            name="new_account_bank_id"
                                            id="new_account_bank_id"
                                            v-model="new_account.bank_id"
                                        >
                                            <option
                                                v-bind:key="bank_id"
                                                v-for="(bank_id, index) in banks"
                                                v-bind:value="bank_id"
                                            >
                                                {{ $t("wallets.bank." + index) }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6" lg="6">
                                    <kt-form-group>
                                        <kt-form-label for="new_account_account_number">
                                            {{ $t("label.account_number") }}
                                        </kt-form-label>
                                        <kt-form-control
                                            dir="ltr"
                                            name="new_account_account_number"
                                            id="new_account_account_number"
                                            v-model="new_account.account_number"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6" lg="6">
                                    <kt-form-group>
                                        <kt-form-label for="new_account_iban">
                                            {{ $t("label.iban") }}
                                        </kt-form-label>
                                        <kt-form-control
                                            style="direction: ltr"
                                            class="form-control sheba"
                                            name="new_account_iban"
                                            id="new_account_iban"
                                            v-model="new_account.iban"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6" lg="6">
                                    <kt-form-group>
                                        <kt-form-label for="new_account_shahab_code">
                                            {{ $t("open_banking.shahab_code") }}
                                        </kt-form-label>
                                        <kt-form-control
                                            dir="ltr"
                                            name="new_account_shahab_code"
                                            id="new_account_shahab_code"
                                            v-model="new_account.shahab_code"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                            </kt-row>
                            <kt-form-action class="mt-4">
                                <kt-button
                                    class="m-2 btn-wide"
                                    size="lg"
                                    variant="success"
                                    type="button"
                                    v-bind:wide="true"
                                    id="add_new_bank_account_btn"
                                    @click="addNewBankAccount()"
                                >
                                    {{ $t('btn.add') }}
                                </kt-button>
                            </kt-form-action>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-row>
</template>

<script>
import $ from "jquery";
import {i18n} from '@/plugins/i18n'
import toastr from "toastr";
import IranSheba from 'iran-sheba'
import Inputmask from "inputmask";
import {bankId} from "@/constants/bankId";
import {
    bankAccessTokenStatus,
    bankAccessTokenStatusStr,
    financialServices
} from "@/constants/openBanking";
import {openBankingService} from "@/common/api.service";


export default {
    props: {
        application: {
            required: true
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    mounted() {
        this.afterDispatch()
        this.initShebaMask()
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })

            if (this.application.bank_accounts.length > 0){
                this.new_account.first_name = this.application.bank_accounts[0].first_name
                this.new_account.last_name = this.application.bank_accounts[0].last_name
            }
        },
        initShebaMask() {
            setTimeout(() => {
                Inputmask("IR 9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('.sheba'))
            }, 500)
        },
        addAccount() {
            this.accounts.push({
                first_name: '',
                last_name: '',
                bank_id: '',
                account_number: '',
                iban: '',
                shahab_code: '',
            });
            this.initShebaMask()
        },
        deleteBankAccount(index) {
            if (this.application.bank_accounts.length < 2) {
                for (var prop in this.financialServices) {
                    if (this.application.services[this.financialServices[prop]].is_selected) {
                        return this.toastr.error(i18n.t('application.message.cannot_delete_bank_account'))
                    }
                }
            }
            var result = confirm(i18n.t('application.message.remove_bank_account_alert'));
            if (!result) return;

            let btn = $('#delete_bank_account_btn' + index)
            btn.prop("disabled", true);

            btn.html(`<div class="d-flex justify-content-center align-items-center"><div class="px-2">لطفا صبر کنید</div><div class="spinner-border spinner-border-sm text-white" role="status"></div></div>`);

            openBankingService.deleteApplicationBankAccount(this.application.id, this.application.bank_accounts[index].id).then(response => {
                this.application.bank_accounts.splice(index, 1)
                this.toastr.success(response.data.message)
            }).catch(({response}) => {
                this.toastr.error(response.data.message)
            }).finally(() => {
                    btn.prop("disabled", false);
                    btn.html(this.$t('btn.delete'));
                }
            )
        },
        addNewBankAccount() {
            let form = $('#add_new_bank_account_form')
            let btn = $('#add_new_bank_account_btn')

            form.validate({
                rules: {
                    new_account_bank_id: {
                        required: true,
                        number: true,
                    },
                    new_account_account_number: {
                        required: true,
                    },
                    new_account_iban: {
                        required: true,
                    },
                    new_account_first_name: {
                        required: true,
                    },
                    new_account_last_name: {
                        required: true,
                    },
                    new_account_shahab_code: {
                        number: true,
                    },
                }
            })
            if (!form.valid()) {
                return
            }

            let sheba = this.correctFormatSheba(this.new_account.iban)
            if (!IranSheba.isValid(sheba))
                return this.toastr.error(i18n.t('deposit.message.sheba_is_not_valid'))
            if (this.new_account.bank_id === this.bankId.saderat &&
                IranSheba.recognize(sheba).nickname !== 'saderat')
                return this.toastr.error(i18n.t('deposit.message.sheba_does_not_belong_to_saderat'))
            if (this.new_account.bank_id === this.bankId.keshavarzi &&
                IranSheba.recognize(sheba).nickname !== 'keshavarzi')
                return this.toastr.error(i18n.t('deposit.message.sheba_does_not_belong_to_keshavarzi'))
            if (this.new_account.bank_id === this.bankId.saman &&
                IranSheba.recognize(sheba).nickname !== 'saman')
                return this.toastr.error(i18n.t('deposit.message.sheba_does_not_belong_to_saman'))

            var all_ibans = [this.correctFormatSheba(this.new_account.iban)]
            let accounts = this.application.bank_accounts
            for (var prop in this.application.bank_accounts) {
                accounts[prop].iban = this.correctFormatSheba(accounts[prop].iban)
                all_ibans.push(accounts[prop].iban)
            }
            var duplicates = all_ibans.filter((item, index) => all_ibans.indexOf(item) !== index);
            if (duplicates.length > 0)
                return this.toastr.error(i18n.t('application.message.duplicate_bank_account'))

            let params = {
                bank_id: this.new_account.bank_id,
                first_name: this.new_account.first_name,
                last_name: this.new_account.last_name,
                account_number: this.new_account.account_number,
                iban: this.correctFormatSheba(this.new_account.iban),
                shahab_code: this.new_account.shahab_code,
            }
            btn.prop("disabled", true);
            btn.html(`<div class="d-flex justify-content-center align-items-center"><div class="px-2">لطفا صبر کنید</div><div class="spinner-border spinner-border-sm text-white" role="status"></div></div>`);

            openBankingService.addApplicationBankAccount(params, this.application.id).then(response => {
                document.getElementById('close_modal').click()
                this.application.bank_accounts.push(response.data.data)
                this.initShebaMask()

                this.new_account = {
                    bank_id: '',
                    first_name: this.new_account.first_name = this.application.bank_accounts[0].first_name,
                    last_name: this.new_account.last_name = this.application.bank_accounts[0].last_name,
                    account_number: '',
                    iban: '',
                    shahab_code: '',
                }

                this.toastr.success(response.data.message)
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.toastr.error(response.data.message)
            }).finally(() => {
                    btn.prop("disabled", false);
                    btn.html(this.$t('btn.add'));
                }
            )

        },
        correctFormatSheba(sheba) {
            sheba = sheba.split('-').join('')
            sheba = sheba.split('_').join('')
            return sheba.split(' ').join('')
        },
        getBankAccountStatusClass (status){
            if (status == bankAccessTokenStatus.PENDING)
                return  'badge badge-warning';
            if (status == bankAccessTokenStatus.ACTIVE)
                return  'badge badge-success';
            if (status == bankAccessTokenStatus.REJECT)
                return  'badge badge-danger';
        }
    },
    data() {
        return {
            banks: {
                keshavarzi: '016',
                saderat: '019',
                saman: '056',
            },
            new_account: {
                first_name: '',
                last_name: '',
                bank_id: '',
                account_number: '',
                iban: '',
                shahab_code: '',
            },
            bankId,
            bankAccessTokenStatus,
            bankAccessTokenStatusStr,
            financialServices
        }
    }
}
</script>

<style>

</style>